import type { Template } from "@/types";

export const PO_05_H2_V3: Template[] = [
    {
        id: "po-05-h2v3-01",
        name: "PO 01 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_01.png",
        size: [1190, 850],
        style: {},
        slots: [          
            { id: "1", x: 73, y: 169, width: 221, height: 347, rotation: 0, imageRotation: 0 },
            { id: "2", x: 302, y: 169, width: 221, height: 347, rotation: 0, imageRotation: 0 },
            { id: "3", x: 73, y: 524, width: 221, height: 157, rotation: 0, imageRotation: 0 },
            { id: "4", x: 302, y: 524, width: 221, height: 157, rotation: 0, imageRotation: 0 },
            { id: "5", x: 670, y: 75, width: 444, height: 701, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-02",
        name: "PO 02 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_02.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 29, y: 0, width: 538, height: 850, rotation: 0, imageRotation: 0 },
            { id: "2", x: 659, y: 151, width: 230, height: 372, rotation: 0, imageRotation: 0 },
            { id: "3", x: 897, y: 151, width: 230, height: 372, rotation: 0, imageRotation: 0 },
            { id: "4", x: 659, y: 530, width: 230, height: 168, rotation: 0, imageRotation: 0 },
            { id: "5", x: 897, y: 530, width: 230, height: 168, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-03",
        name: "PO 03 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_03.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 28, y: 0, width: 527, height: 850, rotation: 0, imageRotation: 0 },
            { id: "2", x: 660, y: 157, width: 225, height: 164, rotation: 0, imageRotation: 0 },
            { id: "3", x: 893, y: 529, width: 226, height: 164, rotation: 0, imageRotation: 0 },
            { id: "4", x: 660, y: 329, width: 225, height: 364, rotation: 0, imageRotation: 0 },
            { id: "5", x: 893, y: 157, width: 226, height: 364, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-04",
        name: "PO 04 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_04.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 80, y: 82, width: 434, height: 686, rotation: 0, imageRotation: 0 },
            { id: "2", x: 655, y: 167, width: 463, height: 330, rotation: 0, imageRotation: 0 },
            { id: "3", x: 774, y: 504, width: 227, height: 180, rotation: 0, imageRotation: 0 },
            { id: "4", x: 655, y: 504, width: 110, height: 180, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1009, y: 504, width: 109, height: 180, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-05",
        name: "PO 05 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_05.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 78, y: 167, width: 421, height: 304, rotation: 0, imageRotation: 0 },
            { id: "2", x: 78, y: 479, width: 278, height: 205, rotation: 0, imageRotation: 0 },
            { id: "3", x: 364, y: 479, width: 136, height: 205, rotation: 0, imageRotation: 0 },
            { id: "4", x: 642, y: 226, width: 247, height: 397, rotation: 0, imageRotation: 0 },
            { id: "5", x: 897, y: 226, width: 247, height: 397, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-06",
        name: "PO 06 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_06.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 54, y: 236, width: 240, height: 378, rotation: 0, imageRotation: 0 },
            { id: "2", x: 302, y: 236, width: 239, height: 378, rotation: 0, imageRotation: 0 },
            { id: "3", x: 897, y: 236, width: 250, height: 378, rotation: 0, imageRotation: 0 },
            { id: "4", x: 641, y: 236, width: 248, height: 185, rotation: 0, imageRotation: 0 },
            { id: "5", x: 641, y: 429, width: 248, height: 185, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-07",
        name: "PO 07 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_07.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 33, y: 201, width: 275, height: 449, rotation: 0, imageRotation: 0 },
            { id: "2", x: 316, y: 201, width: 275, height: 449, rotation: 0, imageRotation: 0 },
            { id: "3", x: 599, y: 201, width: 275, height: 449, rotation: 0, imageRotation: 0 },
            { id: "4", x: 882, y: 201, width: 275, height: 221, rotation: 0, imageRotation: 0 },
            { id: "5", x: 882, y: 430, width: 275, height: 220, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-08",
        name: "PO 08 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_08.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 158, width: 743, height: 534, rotation: 0, imageRotation: 0 },
            { id: "2", x: 751, y: 158, width: 440, height: 311, rotation: 0, imageRotation: 0 },
            { id: "3", x: 751, y: 476, width: 142, height: 216, rotation: 0, imageRotation: 0 },
            { id: "4", x: 901, y: 476, width: 141, height: 216, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1050, y: 476, width: 141, height: 216, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-09",
        name: "PO 09 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_09.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 35, y: 205, width: 274, height: 439, rotation: 0, imageRotation: 0 },
            { id: "2", x: 599, y: 205, width: 274, height: 439, rotation: 0, imageRotation: 0 },
            { id: "3", x: 881, y: 205, width: 274, height: 439, rotation: 0, imageRotation: 0 },
            { id: "4", x: 317, y: 205, width: 274, height: 216, rotation: 0, imageRotation: 0 },
            { id: "5", x: 317, y: 429, width: 274, height: 216, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-10",
        name: "PO 10 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_10.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 191, width: 292, height: 468, rotation: 0, imageRotation: 0 },
            { id: "2", x: 300, y: 191, width: 292, height: 468, rotation: 0, imageRotation: 0 },
            { id: "3", x: 899, y: 191, width: 291, height: 468, rotation: 0, imageRotation: 0 },
            { id: "4", x: 600, y: 191, width: 291, height: 230, rotation: 0, imageRotation: 0 },
            { id: "5", x: 600, y: 429, width: 291, height: 230, rotation: 0, imageRotation: 0 }
        ],
    }
];